import { Component, OnInit,Input  } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DoctorsService } from '../doctor-service/doctors.service';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { map, take } from 'rxjs/operators';
import * as moment from 'moment';
@Component({
  selector: 'app-token-screen',
  templateUrl: './token-screen.component.html',
  styleUrls: ['./token-screen.component.css']
})
export class TokenScreenComponent implements OnInit {
  @Input() clinicId: string;
  @Input() slots:Number;
  tokens: number[] = null;
  bookedToken:number[] = null;
  pendingToken:number[] = null;
  discount:any;
  curToken:number ;
  slot:number = 1;
  minDate:Date = new Date();
  moment:any = moment;
  showAppt:Boolean = false;
  recptform1: FormGroup;
  id: any;
  showAdavnce: boolean = false;
  userToken: string;
  doctype: string;
  members: any;
  member: any;
  test: any;
  items: any;
  testArray: any[];
  ammount: number = null;
  isLoading: boolean;
  deposit: number = null;
  paymentType: any = "cash";
  bookappointment: any;
  selectedItems: any[];
  selectedDate:Date=new Date();
  bookedTokenObject: any ={};
  constructor(
    private doctorService: DoctorsService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.authService.authDataSubject.pipe(take(1)).subscribe(authData => {
      this.userToken = authData._token;
      this.id = authData._id;
      this.doctype = authData._type;
      // console.log(this.id);
    });
    this.recptform1 = new FormGroup({
      ageType: new FormControl('year',Validators.required),
      GuardiansName : new FormControl(null),
      patientGender: new FormControl('MALE'),
      doctorId: new FormControl(this.id),
      phoneNo: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      patientAge: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      patientName: new FormControl(null,Validators.required),
      address: new FormControl(null),
      skipDays: new FormControl(0),
      appointmentDate:new FormControl(moment()),
      nameTitle: new FormControl('Mr.'),
      GuardiansNameTitle: new FormControl('S/O')
    });

    this.getAppontmentDetail();
  }
  getTokenStatusClass(token: number) {
    if (this.bookedToken.includes(token)) {
      return 'booked';
    } else if (this.pendingToken.includes(token)) {
      return 'pending';
    } else {
      return 'available';
    } 
  }

  onChangeDiscount(value){
    console.log(value.target.value);
    this.discount = value.target.value
    let amount= 0
    this.selectedItems.map((t)=>{
      var price = this.test.filter((item)=> item.testId._id === t)[0].price;
      console.log(price)
      amount = amount + price;
    });
    console.log(amount);
    this.ammount = amount;
    this.ammount = this.ammount - value.target.value;
  }
  getTokenbackgroundClass(token: number){
    if (this.bookedToken.includes(token)) {
      return 'bookedBackground';
    } else if (this.pendingToken.includes(token)) {
      return 'pendingBackground';
    } else {
      return 'availableBackground';
    } 
  }
  getCurToken(token){
    // alert(token);
    this.curToken=token;
    this.recptform1 = new FormGroup({
      ageType: new FormControl('year',Validators.required),
      GuardiansName : new FormControl(null),
      patientGender: new FormControl('MALE'),
      doctorId: new FormControl(this.id),
      phoneNo: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      patientAge: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      patientName: new FormControl(null,Validators.required),
      address: new FormControl(null),
      skipDays: new FormControl(0),
      appointmentDate:new FormControl(moment()),
      nameTitle: new FormControl('Mr.'),
      GuardiansNameTitle: new FormControl('S/O')
    });
    this.showAppt = false;
  }
  onAdvance(){
    this.showAdavnce = !this.showAdavnce;
    if(this.showAdavnce)
    this.getMember(this.clinicId)
    this.getTest()
  }
  getMember(clinicId){
    this.doctorService.getMember(clinicId,this.userToken).subscribe((res:any)=>{
      // console.log(res);
      this.members= res;
      this.member = this.members[0]._id;
    })
  }
  getTest(){
    // console.log(this.clinicId,"this is clinicId")
    this.doctorService.getTest(this.userToken,this.clinicId).subscribe((res:any)=>{
      // console.log("this is response",res);
      
      this.test= res.tests;
      this.items = this.test.map((t)=>({label:t.testId.name+"("+t.price+")",value:t.testId._id}))
      // console.log(this.test,"this is trsts");
    })
  }
  onChangeTests(value){
    // console.log(value.value);
    var amount = 0;
    this.testArray= [];
    value.value?.map((t)=>{
      var price = this.test.filter((item)=> item.testId._id === t)[0].price;
      this.testArray.push({id:t,price:price});
      amount = amount + price;
    });
    // console.log(amount);
    this.ammount = amount
  }
  Bookreceptionist(){
    this.isLoading = true;
    var finalData = {...this.recptform1.value,...{appointmentDate:moment(this.selectedDate).set({
      hours:12
    }).toDate(),appointmentNumber:this.curToken,slot:this.slot,clinicId:this.clinicId,patientName:this.recptform1.value.nameTitle+" "+this.recptform1.value.patientName,
    patientGender:this.recptform1.value.nameTitle === 'Mr.'?'MALE':'FEMALE',GuardiansName:this.recptform1.value.GuardiansName ? this.recptform1.value.GuardiansNameTitle+" "+this.recptform1.value.GuardiansName:null}}
    // console.log("this is form control value ",finalData);
    this.doctorService.bookApptMultipleDays(finalData, this.userToken).subscribe((res:any) =>
      {
       if(this.showAdavnce) {
          let postData = {
          testId:this.testArray,
          memberId:this.member,
          amount:this.ammount,
          deposit:this.deposit,
          discount: this.discount,
          balance:this.ammount- this.deposit,
          paymentType:this.paymentType,
          appointmentId:res.savedAppointment._id
        };
        this.doctorService.saveAppointmentTransaction(postData,this.userToken).subscribe((response)=>{
          this.isLoading = false;
          this.bookappointment = res.savedAppointment;
          this.showAdavnce = false;
          this.testArray = [];
          this.ammount = null;
          this.member = this.members[0]._id;
          this.deposit = null;
          this.discount = this.discount;
          this.selectedItems = [];
          this.getAppontmentDetail();
          this.showAppt = true;
          // window.alert(`${this.bookappointment.patientName} , Your Appointment is Booked Successfully. Your Appointment Number is ${this.bookappointment.appointmentNumber}`);
          // console.log('this is receptionist', res);
        })
      }else{
        this.isLoading = false;
          this.showAdavnce = false;
          this.bookappointment = res.savedAppointment;
          this.getAppontmentDetail();
          this.showAppt = true;
          // window.alert(`${this.bookappointment.patientName} , Your Appointment is Booked Successfully. Your Appointment Number is ${this.bookappointment.appointmentNumber}`);
          // console.log('this is receptionist', res);
      }
      },(err)=>{
        this.isLoading=false;
        alert(err.error.message);
        // console.log("this is error",err);
        if(err.error.status >= 400){
          // alert(err.error.message);
        }
      }
    )
  }
  onNewPatient(){
    this.recptform1 = new FormGroup({
      ageType: new FormControl('year',Validators.required),
      GuardiansName : new FormControl(null),
      patientGender: new FormControl('MALE'),
      doctorId: new FormControl(this.id),
      phoneNo: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      patientAge: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      patientName: new FormControl(null,Validators.required),
      address: new FormControl(null),
      skipDays: new FormControl(0),
      appointmentDate:new FormControl(moment()),
      nameTitle: new FormControl('Mr.'),
      GuardiansNameTitle: new FormControl('S/O')
    });
    this.showAppt = false;
  }
  onChangeAmmount(value){
    // console.log(value.target.value);
    this.ammount = Number(value.target.value);
  }
  onChangeDeposit(value){
    // console.log(value.target.value);
    this.deposit = Number(value.target.value);
  }
  getAppontmentDetail(){
    this.doctorService.getAppontmentDetail(this.clinicId,this.selectedDate,this.userToken,this.slot).subscribe((res:any)=>{
      // console.log("this is tokes value ",res);
      this.bookedToken = res.bookappointment.map(appt=>(appt.appointmentNumber));
      this.bookedTokenObject
      res.bookappointment.map((appt)=>{
        this.bookedTokenObject[appt.appointmentNumber] = {};
        this.bookedTokenObject[appt.appointmentNumber] = (appt.patientName.length > 9)?appt.patientName.slice(0, 7)+'...':appt.patientName;
      })
      console.log(this.bookedTokenObject);
      this.pendingToken = res.pendingAppt;
      this.tokens = res.tokens;
    })
   }
   onDateChange(event){
    console.log("this is event",event);
    console.log(moment(event).set({
      hours:12
    }).toDate());
    this.selectedDate = event;
    this.getAppontmentDetail();
   }
   changeSlot(event){
    this.slot = event.target.value;
    this.getAppontmentDetail();
   }
}
